import React from 'react'
import {useTranslation} from '../../../util/i18n'
import {style} from '../../../util/style'
import {CardSwitchType} from '../../layout/cards/CardSwitch'
import {EventCardType} from '../../layout/cards/EventCard'
import {Overview} from '../../layout/Overview'
import {Theme} from '../../Theme'

const styles = style('eventsoverview')

type EventsOverviewType = {
	events: Array<EventCardType>
	overview_title?: string
	card_linklabel?: string
}

export const EventsOverview: React.FC<EventsOverviewType> = ({
	events,
	overview_title,
	card_linklabel
}) => {
	const t = useTranslation('agenda').filters.errors
	const hasItems = events?.length > 0

	return (
		<div className={styles()}>
			{hasItems && (
				<Overview
					title={overview_title}
					layout="event"
					items={events as Array<CardSwitchType>}
					card_linklabel={card_linklabel}
					maxBeforeLoadMore={6}
					loadItemsPerLoadMore={6}
				/>
			)}
			{!hasItems && (
				<Theme.Container>
					<div className={styles('state')}>
						<Theme.P>{t.no_results}</Theme.P>
					</div>
				</Theme.Container>
			)}
		</div>
	)
}
